import { friendlyName, isField } from '../../../../types/field';
import { getItemLabelWithoutTableName } from '../../../../utils/item';
export const formatFieldLabel = (fieldId, fieldsMap) => {
    const field = fieldsMap[fieldId];
    if (field && isField(field)) {
        return getItemLabelWithoutTableName(field);
    }
    return friendlyName(fieldId);
};
//# sourceMappingURL=formatFieldLabel.js.map